<div id="tabPartnerData"  [formGroup]="_form">
        <div class="row" *ngIf="form.value.form_HeadFamilyData && form.value.form_HeadFamilyData.marital_status == 2">
            <div class="col-md-12 col-xs-12 group">                
                <div class="row">
                    <div class="col-md-12 col-xs-12 group-title">
                        <h5>מילוי נתונים אישיים</h5>
                    </div>
                </div>
                
                <personal-info [form]="_form" [isSocialID_Mandarory]="isSocialID_Mandarory" relation= "בן/בת זוג"></personal-info>

                <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <israely-status [form]="_form" (statChanged)="checkIsraelyStatus($event)"></israely-status>
                    </div>
                </div>
                
                <div class="row">
                        <div class="col-md-12 col-xs-12">
                            <div class="row">
                                    <div class="col-md-12 col-xs-12">
                                            <yes-no [form]="_form" controlName="moia_donation" 
                                                    text="קיבלתי בעבר סיוע כעולה ממשרד העלייה והקליטה">
                                            </yes-no> 
                                    </div>
                            </div>
                            <div class="row">
                                    <div class="col-md-12 col-xs-12">
                                        <yes-no [form]="_form" controlName="returning_donation" 
                                                text="קיבלתי בעבר סיוע כתושב חוזר ממשרד העלייה והקליטה">
                                        </yes-no> 
                                    </div>
                            </div>
                            <br>
                        </div>                        
                </div>
                <div > 
                    <last-works [form]="_form"></last-works>  
                </div>
            </div>
        </div>
</div>